export const Constants = {
  logo: '/assets/images/kate-and-adam.png'
}
